import React, {memo, type ReactNode} from 'react';

import moment from 'moment-tz';

import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {getElapsedTime} from 'app/general/dates';
import updateIntervalEnhancer, {
  type UpdateIntervalEnhancerProps,
} from 'app/general/updateIntervalEnhancer';
import {gt} from 'app/utils/i18n';

import type {OverlayPlacementType} from 'app/general/overlays';
type Props = {
  className?: string;
  timestamp: string;
  wrapText?: string;
  wrapTextFn?: (arg0: string) => ReactNode;
  wrapTooltip?: (arg0: string) => ReactNode;
  tooltipPlacement?: OverlayPlacementType;
  ContainerTag?: 'span' | 'small' | 'div';
  small?: boolean;
};

const ElapsedTime = ({
  timestamp,
  wrapText,
  wrapTextFn,
  tooltipPlacement = 'bottom',
  ContainerTag = 'span',
  small = false,
  wrapTooltip,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  tickIndex,
  ...other
}: Props & UpdateIntervalEnhancerProps) => {
  const elapsedTime = getElapsedTime(timestamp);
  const formattedTime = moment(timestamp).format('lll');
  const TextContainerTag = small ? 'small' : 'span';
  return (
    <LazyTooltip
      placement={tooltipPlacement}
      tooltip={
        wrapTooltip != null ? (
          wrapTooltip(formattedTime)
        ) : (
          <TextContainerTag>{formattedTime}</TextContainerTag>
        )
      }
    >
      <ContainerTag {...other}>
        {wrapTextFn != null
          ? wrapTextFn(elapsedTime)
          : wrapText != null
          ? gt(wrapText, elapsedTime)
          : elapsedTime}
      </ContainerTag>
    </LazyTooltip>
  );
};

ElapsedTime.displayName = 'ElapsedTime';
export default memo<Props>(
  updateIntervalEnhancer<Props>(ElapsedTime, 60 * 1000)
);
